import { render, staticRenderFns } from "./DetailsAnalyticsModal.vue?vue&type=template&id=61a68a4d&scoped=true"
import script from "./DetailsAnalyticsModal.vue?vue&type=script&lang=js"
export * from "./DetailsAnalyticsModal.vue?vue&type=script&lang=js"
import style0 from "./DetailsAnalyticsModal.vue?vue&type=style&index=0&id=61a68a4d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a68a4d",
  null
  
)

export default component.exports